'use strict';

/**
 * Validates and Return the cquotient namespace provided by the commerce cloud platform
 * @returns {Object} - einsteinUtils or null
 */
function getEinsteinUtils() {
    var einsteinUtils = window.CQuotient;
    if (einsteinUtils && typeof einsteinUtils.getCQUserId === 'function' && typeof einsteinUtils.getCQCookieId === 'function') {
        return einsteinUtils;
    }
    return null;
}

/**
 * fills in the carousel with product tile html objects
 * @param {string} einsteinResponse string html for product tiles
 * @param {jQuery} $parentElement parent element where recommendations will show.
 */
function fillDomElement(einsteinResponse, $parentElement) {
    var recommender = $parentElement.data('recommender');
    var recommendedProducts = einsteinResponse[recommender].recs;
    if (recommendedProducts && recommendedProducts.length > 0) {
        var template = $parentElement.data('template');
        var components = [];
        components = recommendedProducts.map(function (recommendedProduct) {
            var tiledefinition = {};
            tiledefinition.template = template;
            tiledefinition.model = {
                type: 'product',
                id: recommendedProduct.id,
            };
            return tiledefinition;
        });

        var url = new URL($parentElement.data('product-load-url'));
        url.searchParams.append('components', JSON.stringify(components));
        url.searchParams.append('limit', $parentElement.data('limit'));
        url.searchParams.append('showSustainabilityTags', $parentElement.data('show-sustainability-tags'));
        url.searchParams.append('showAllImages', $parentElement.data('show-all-images'));
        url.searchParams.append('hideBody', $parentElement.data('hide-body'));
        url.searchParams.append('showBadges', $parentElement.data('show-badges'));
        url.searchParams.append('showQuickView', $parentElement.data('show-quick-view'));
        url.searchParams.append('recommender', recommender);
        $.ajax({
            url: url.href,
            type: 'get',
            dataType: 'html',
            success: function (html) {
                let $carousel = $parentElement.find('.product-carousel');
                const $html = $('<div>').html(html);
                const $children = $html.children();
                // Move <script> inside next .reco-product-wrapper
                $children.each(function (index) {
                    const $elem = $(this);
                    if ($elem.is('script')) {
                        const $next = $children.eq(index + 1);
                        if ($next.hasClass('reco-product-wrapper')) {
                            $next.append($elem);
                        }
                    }
                });
                $carousel.html($html.find('.reco-product-wrapper'));
                $carousel.removeClass('product-carousel-loading').addClass('product-carousel-loaded');
                $parentElement.find('.product-carousel__title').removeClass('d-none');
                $(document).trigger('initProductCarousel', {
                    element: $carousel,
                });
                $(document).trigger('wishlist:check');
            },
            error: function () {
                $parentElement.spinner().stop();
            },
        });
    } else {
        let $carousel = $parentElement.find('.product-carousel');
        $carousel.removeClass('product-carousel-loading').addClass('product-carousel-empty');
        $parentElement.find('.product-carousel__title').addClass('d-none');
    }
}

/**
 * Processes a recommendation tile, with an already initialized category specific anchors array
 * @param {jQuery} $parentElement parent element where recommendations will show.
 * @param {Object} einsteinUtils cquotient object
 * @param {Array} anchorsArray array of objects representing anchors
 */
function processRecommendationsTile($parentElement, einsteinUtils, anchorsArray) {
    var recommender = $parentElement.data('recommender');

    var params = {
        userId: einsteinUtils.getCQUserId(),
        cookieId: einsteinUtils.getCQCookieId(),
        ccver: '1.01',
    };

    if (anchorsArray) {
        params.anchors = anchorsArray;
    }

    /**
     * Processes a recommendation responses
     * @param {Object} einsteinResponse cquotient object
     */
    function recommendationsReceived(einsteinResponse) {
        fillDomElement(einsteinResponse, $parentElement);
        $parentElement.spinner().stop();
    }

    if (einsteinUtils.getRecs) {
        einsteinUtils.getRecs(einsteinUtils.clientId, recommender, params, recommendationsReceived);
    } else {
        einsteinUtils.widgets = einsteinUtils.widgets || []; // eslint-disable-line no-param-reassign
        einsteinUtils.widgets.push({
            recommenderName: recommender,
            parameters: params,
            callback: recommendationsReceived,
        });
    }
}

/**
 * Processes a recommendation tile, with an already initialized product specific anchors array
 * @param {jQuery} $parentElement parent element where recommendations will show.
 * @returns {Array} - containing an anchor object
 */
function createProductAnchor($parentElement) {
    return [
        {
            id: $parentElement.data('primaryProductId'),
            sku: $parentElement.data('secondaryProductId'),
            type: $parentElement.data('alternativeGroupType'),
            alt_id: $parentElement.data('alternativeGroupId'),
        },
    ];
}

/**
 * Rerieves data attributes from parent element and converts to gretel compatible recommenders array
 * @param {jQuery} $parentElement parent element where recommendations will show.
 * @returns {Array} - containing an anchor object
 */
function createCategoryAnchor($parentElement) {
    return [{ id: $parentElement.data('categoryId') }];
}

/**
 * Gets all placeholder elements, which hold einstein recommendations queries the details from the
 * einstein engine and feeds them back to the dom element
 */
function loadRecommendations() {
    var einsteinUtils = getEinsteinUtils();
    if (einsteinUtils) {
        var $recommendationTiles = $('.einstein-carousel');
        $recommendationTiles.each(function () {
            var $parentElement = $(this);
            if (!$parentElement.hasClass('product-carousel-loaded')) {
                $parentElement.spinner().start();
                if ($(this).closest('.experience-einstein-einsteinCarouselProduct').length) {
                    processRecommendationsTile($parentElement, einsteinUtils, createProductAnchor($parentElement));
                } else if ($(this).closest('.experience-einstein-einsteinCarouselCategory').length) {
                    processRecommendationsTile($parentElement, einsteinUtils, createCategoryAnchor($parentElement));
                } else {
                    processRecommendationsTile($parentElement, einsteinUtils);
                }
            }
        });
    }
}

const $document = $(document);
$document.ready(function () {
    loadRecommendations();
    $document.on('reloadEinstein', function () {
        loadRecommendations();
    });
});
